"use strict";

const acceptButton = document.querySelector('.js-cache-notification button');
if (acceptButton) {
    acceptButton.addEventListener('click', acceptCacheNotification, false);
    checkForCacheConfirmation();
}

function checkForCacheConfirmation() {
    let confirmation = window.localStorage.getItem('cache-confirmation');
    if (confirmation) {
        hideCacheNotification();
    }
}

function acceptCacheNotification() {
    let confirmation = window.localStorage.getItem('cache-confirmation');
    if (!confirmation) {
        window.localStorage.setItem('cache-confirmation', true);
        hideCacheNotification();
    }
}

function hideCacheNotification() {
    const cacheNotification = document.querySelector('.js-cache-notification');
    cacheNotification.classList.toggle('active');
}

export function getLocalStorage(key) {
    const value = window.localStorage.getItem(key);
    return value ? value.split(",") : [];
}

export function setLocalStorage(key, value) {
    window.localStorage.setItem(key, value);
}